import dayjs from 'dayjs'
import Big from 'big.js'
export { getTableTotal, MEMBER_TABLE_PAGE_SIZE as RECORD_PAGE_SIZE } from '../../table-utils'

export const BALANCE_CHANGE_RECORD_TYPE_LIST = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]

export const BALANCE_CHANGE_RECORD_TYPE_MAP: { [key: number]: string } = {
    0: '收银台充值',
    1: '门店订单消费',
    2: '门店订单退款',
    3: '充值送',
    4: '商城订单消费',
    5: '商城消费退款',
    6: '配货后补款',
    7: '配货后退款',
    8: '零售通充值',
    9: '自助充值',
    10: '老零售会员同步',
    11: '会员合并',
    12: '会员余额退款',
    13: '异常余额校正',
    14: '找零存入余额',
}

export const POINTS_CHANGE_TYPE_LIST = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

export const POINTS_CHANGE_TYPE_MAP: { [key: number]: string } = {
    0: '消费送积分',
    1: '订单退款',
    2: '抵现扣积分',
    3: '商城消费送积分',
    4: '商城订单退款',
    5: '商城抵现扣积分',
    6: '老零售积分同步',
    7: '按周期重新计算',
    8: '连锁会员合并',
    9: '手动增加',
    10: '手动扣减',
    11: '积分兑换优惠券',
}

export const CHAIN_COIN_CHANGE_TYPE_LIST = [0, 1, 2, 3, 4, 5, 6]

export const CHAIN_COIN_CHANGE_TYPE_MAP: { [key: number]: string } = {
    0: '消费送连锁币',
    1: '订单退款',
    2: '抵现扣连锁币',
    3: '商城消费送连锁币',
    4: '商城订单退款',
    5: '商城抵现扣连锁币',
    6: '连锁币兑换共享值',
}

export const formatDateTime = (date?: string) => (date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : '-')

export const formatAmount = (amount?: string | number) =>
    amount === undefined || amount === null || amount === '' ? '-' : amount

export const getCombinedBalanceAmount = (amount?: string | number, bonus?: string | number) => {
    if ([amount, bonus].every(value => value === undefined || value === null || value === '')) {
        return '-'
    }

    return +Big(amount || 0).plus(bonus || 0)
}

const hasBonus = (bonus?: string | number) =>
    bonus !== undefined && bonus !== null && bonus !== '' && Number(bonus) !== 0

export const formatBonusHint = (bonus?: string | number) => (hasBonus(bonus) ? `（含赠送金 ${bonus} 元）` : '')

export const getCombinedBalanceText = (amount?: string | number, bonus?: string | number) => {
    const combinedAmount = getCombinedBalanceAmount(amount, bonus)

    if (combinedAmount === '-') {
        return combinedAmount
    }

    return `${combinedAmount}${formatBonusHint(bonus)}`
}

export const getBalanceChangeAmount = (recordType: number, amount?: string | number, bonus?: string | number) => {
    const combinedAmount = getCombinedBalanceAmount(amount, bonus)

    if (combinedAmount === '-') {
        return combinedAmount
    }

    return `${[1, 4, 6, 12].includes(recordType) ? '-' : '+'}${combinedAmount}${formatBonusHint(bonus)}`
}

export const getShopName = (shop?: { shop_name?: string; name?: string }) => shop?.shop_name || shop?.name || '-'

export const getOperatorName = (creator?: {
    name?: string
    realname?: string
    nickname?: string
    user?: { realname?: string; nickname?: string }
}) =>
    creator?.user?.realname || creator?.user?.nickname || creator?.realname || creator?.nickname || creator?.name || '-'

export const getPaymentText = (
    payment?:
        | string
        | number
        | { payment_type_text?: string; custom_payment?: { name?: string } }
        | Array<{ payment_type_text?: string; custom_payment?: { name?: string } }>,
) => {
    if (typeof payment === 'string' || typeof payment === 'number') {
        return payment === '' || payment === undefined || payment === null ? '-' : payment
    }

    if (Array.isArray(payment)) {
        return (
            payment
                .map(item => item.custom_payment?.name || item.payment_type_text)
                .filter(Boolean)
                .join('、') || '-'
        )
    }

    return payment?.custom_payment?.name || payment?.payment_type_text || '-'
}
